module.exports = __webpack_public_path__ + "static/media/Zalishuk_gif_tv.26b0a072.gif";